"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHtmlElementSize(element) {
    if (element) {
        var boundingClientRect = element.getBoundingClientRect();
        var style = window.getComputedStyle(element);
        var x = boundingClientRect.x, y = boundingClientRect.y, bottom = boundingClientRect.bottom, top_1 = boundingClientRect.top, left = boundingClientRect.left, right = boundingClientRect.right, height = boundingClientRect.height, width = boundingClientRect.width;
        var boundingClientRectResponse = {
            x: x,
            y: y,
            bottom: bottom,
            top: top_1,
            left: left,
            right: right,
            height: height,
            width: width,
        };
        if (style.position === 'absolute') {
            boundingClientRectResponse.height = 0;
            boundingClientRectResponse.width = 0;
        }
        else {
            var heightModifiers = ['marginTop', 'marginBottom'];
            boundingClientRectResponse.height = applySizeModifiers(height, heightModifiers, style);
            var widthModifiers = ['marginLeft', 'marginRight'];
            boundingClientRectResponse.width = applySizeModifiers(width, widthModifiers, style);
        }
        return boundingClientRectResponse;
    }
}
exports.getHtmlElementSize = getHtmlElementSize;
function applySizeModifiers(baseValue, modifierKeys, style) {
    var value = baseValue;
    for (var _i = 0, modifierKeys_1 = modifierKeys; _i < modifierKeys_1.length; _i++) {
        var modifierKey = modifierKeys_1[_i];
        var modifierValueRaw = style[modifierKey];
        if (modifierValueRaw) {
            value += getPixelValue(modifierValueRaw);
        }
    }
    return value;
}
exports.applySizeModifiers = applySizeModifiers;
function getPixelValue(value) {
    return parseFloat(value.replace('px', ''));
}
exports.getPixelValue = getPixelValue;
//# sourceMappingURL=layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/layout.js
// module id = 745
// module chunks = 1